import Layout from '../components/layout';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import styles from '../styles/privacy.module.scss';
import { privacyList } from '../constants/privacy';

export default function Privacy() {
  const router = useRouter();
  const { t } = useTranslation('privacy');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <section className={styles.privacy}>
            <h2>{t('privacyTitle')}</h2>
            <p className={styles.description}>{t('description')}</p>
            <div className={styles.content}>
              {privacyList.map((el,index) =>  <div key={index} dangerouslySetInnerHTML={{__html: t(el.block, { interpolation: { escapeValue: false }})}} />)}
            </div>
        </section>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['privacy', 'common']),
  },
});
